import React from "react";
import Main from "./Main";
import About from "./About";
import Tutorial from "./Tutorial";
import Card from "./Card";
import Discount from "./Discount";
import Review from "./Review";
import Meet from "./Meet";
import Prricing from "./Prricing";
import Infra from "./Infra";

const AaraClouds = () => {
  return (
    <>
      <Main />
      <About />
      <Tutorial />
      <Card />
      {/* <Discount /> */}
      <Review />
      <Meet />
      <Prricing />
      <Infra/>
    </>
  );
};

export default AaraClouds;
